import { render, staticRenderFns } from "./editPPOBProduct.vue?vue&type=template&id=3d388e71&scoped=true&"
import script from "./editPPOBProduct.vue?vue&type=script&lang=js&"
export * from "./editPPOBProduct.vue?vue&type=script&lang=js&"
import style0 from "./editPPOBProduct.vue?vue&type=style&index=0&id=3d388e71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d388e71",
  null
  
)

export default component.exports